module.exports = __webpack_public_path__ + "051da16c9ec4dffdca1e277ae942e98d.svg";